var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-smiley-buttons"},_vm._l((_vm.buttons),function(button){return _c('SmileyButton',{key:button,attrs:{"type":button},model:{value:(_vm.vmValue),callback:function ($$v) {_vm.vmValue=$$v},expression:"vmValue"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }